import React from "react";
import { SettingRow } from "../SettingRow";
import { Checkbox } from "../../../../../../common/components/input/Checkbox";

export const ConsentBannerConsentRequiredRow = () => {
  return (
    <SettingRow
      maxWidthChildren={true}
      title="Require Consent Choice"
      helpText="Enable this setting to require that consumers make a consent choice before being allowed to interact with your website."
    >
      <Checkbox
        field="consentRequired"
        label="Block visitors from interacting with website until a consent choice is made"
      />
    </SettingRow>
  );
};
